import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RoundedCornerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"rounded_corner"}/>
}
